import React, { useEffect, useState } from "react";
import { FaApple, FaGooglePlay, FaStar } from "react-icons/fa";
import { postFormDataCall } from "../../services/apiCall";
import { getPayloadHash } from "../../services/helper";
import CustomTestimonialSlider from "../../Components/sliders/CustomTestimonialSlider";
import { Link, useNavigate } from "react-router-dom";
import { useInfoProvider } from "../../context/InfoContext";
import FAQs from "../../Components/FAQ/FAQ";

const Home = () => {
  const navigate = useNavigate();
  const { info } = useInfoProvider();
  const stats = [
    {
      icon: (
        <img
          src="https://demo.websolutionus.com/aabcserv/uploads/custom-images/counter--2022-09-29-12-40-42-5094.png"
          alt="Partners"
        />
      ),
      value: "100+",
      label: "Total Partners",
    },
    {
      icon: (
        <img
          src="https://demo.websolutionus.com/aabcserv/uploads/custom-images/counter--2022-09-29-12-41-15-9354.png"
          alt="Users"
        />
      ),
      value: "150+",
      label: "Active Users",
    },
    {
      icon: (
        <img
          src="https://demo.websolutionus.com/aabcserv/uploads/custom-images/counter--2022-09-29-12-41-37-4353.png"
          alt="Members"
        />
      ),
      value: "100+",
      label: "Active Members",
    },
    {
      icon: (
        <img
          src="https://demo.websolutionus.com/aabcserv/uploads/custom-images/counter--2022-09-29-12-42-06-6458.png"
          alt="Experience"
        />
      ),
      value: "5+",
      label: "Years of Experience",
    },
  ];

  const [serviceOption, setServiceOption] = useState([]);

  const getServices = async () => {
    const payload = {};
    let dataToSend = { data: getPayloadHash({ data: payload }) };

    let response = await postFormDataCall("/service-for-user", {}, dataToSend);
    if (response?.success && response?.data) {
      setServiceOption(response?.data);
    }
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <div className="w-full">
      {/* <div className="bg-[#f1f8ff]  min-h-screen flex flex-col items-center justify-center p-4"> */}
      <div className="bg-gradient-to-b from-[#4A90E2] to-[#B3DAF1] min-h-screen flex flex-col items-center justify-center p-4">
        <div className="max-w-7xl w-full flex flex-col md:flex-row items-center justify-between">
          <div className="md:w-1/2 text-center md:text-left p-4">
            {/* <p className="text-gray-100 text-xl font-medium mb-4">
              GIGSAM – Connecting People
            </p> */}
            <h1 className="text-3xl md:text-4xl font-bold text-white">
              A <span className="text-blue-600">Trusted Hiring Partner! </span>
              Find Work & Hire Fast – Anytime, Anywhere!
            </h1>
            <p className="text-white mt-4 font-medium text-xl">
              Whether you’re looking for flexible part-time work solution or a
              dedicated hiring team to find top talent for full time employment,
              we’ve got you covered.
            </p>
          </div>
          <div className="md:w-1/2 flex justify-center items-center relative mt-6 md:mt-0">
            <div className="w-64 h-64 md:size-full overflow-hidden relative">
              <img
                src="https://demo.websolutionus.com/aabcserv/uploads/website-images/slider-2022-10-01-11-03-17-9020.png"
                alt="Main Service"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our Verticals
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
          </div>

          {/* PeopleFusionHR Section */}
          <div className="max-w-6xl mx-auto mb-20">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl">
              <div className="md:flex">
                <div className="md:w-1/3 bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center p-8">
                  <div className="text-center">
                    <div className="bg-white/20 p-4 rounded-full inline-block mb-6">
                      <svg
                        className="h-12 w-12 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">
                      PeopleFusionHR
                    </h3>
                    <p className="text-blue-100">
                      Comprehensive Full-Time Employment Solutions
                    </p>
                  </div>
                </div>
                <div className="md:w-2/3 p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Job Seeker Card */}
                    <div className="bg-gray-50 rounded-lg p-6 hover:bg-white transition-all border border-gray-100 hover:border-blue-200 hover:shadow-md">
                      <div className="flex items-center mb-4">
                        <div className="bg-green-100 p-3 rounded-full mr-4 flex-shrink-0">
                          <svg
                            className="h-6 w-6 text-green-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </div>
                        <h4 className="text-lg font-bold text-gray-800">
                          Job Seeker
                        </h4>
                      </div>
                      <p className="text-gray-600 mb-4">
                        Looking for full-time employment opportunities? Submit
                        your details and we'll connect you with matching
                        employers.
                      </p>
                      <a
                        href={info?.google_form_worker || "#"}
                        target="_blank"
                        className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium group"
                      >
                        Access Worker Inquiry Form
                        <svg
                          className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </div>

                    {/* Job Provider Card */}
                    <div className="bg-gray-50 rounded-lg p-6 hover:bg-white transition-all border border-gray-100 hover:border-blue-200 hover:shadow-md">
                      <div className="flex items-center mb-4">
                        <div className="bg-indigo-100 p-3 rounded-full mr-4 flex-shrink-0">
                          <svg
                            className="h-6 w-6 text-indigo-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                          </svg>
                        </div>
                        <h4 className="text-lg font-bold text-gray-800">
                          Job Provider
                        </h4>
                      </div>
                      <p className="text-gray-600 mb-4">
                        Hiring companies & households - Find qualified
                        candidates for your full-time positions.
                      </p>

                      <a
                        href={info?.google_form_employee || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium group"
                      >
                        Access Employer Inquiry Form
                        <svg
                          className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Gigz Section */}
          <div className="max-w-6xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl">
              <div className="md:flex flex-row-reverse">
                <div className="md:w-1/3 bg-gradient-to-br from-purple-600 to-purple-800 flex items-center justify-center p-8">
                  <div className="text-center">
                    <div className="bg-white/20 p-4 rounded-full inline-block mb-6">
                      <svg
                        className="h-12 w-12 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                        />
                      </svg>
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-2">Gigz</h3>
                    <p className="text-purple-100">
                      Flexible Part-Time Workforce Solutions
                    </p>
                  </div>
                </div>
                <div className="md:w-2/3 p-8">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Partners Card */}
                    <div className="bg-gray-50 rounded-lg p-6 hover:bg-white transition-all border border-gray-100 hover:border-purple-200 hover:shadow-md">
                      <div className="flex items-center mb-4">
                        <div className="bg-amber-100 p-3 rounded-full mr-4 flex-shrink-0">
                          <svg
                            className="h-6 w-6 text-amber-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                            />
                          </svg>
                        </div>
                        <h4 className="text-lg font-bold text-gray-800">
                          Partners
                        </h4>
                      </div>
                      <p className="text-gray-600 mb-4">
                        Part-time workers - Register to find flexible gig
                        opportunities that fit your schedule.
                      </p>
                      <a
                        href={info?.google_form_employee || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-purple-600 hover:text-purple-800 font-medium group"
                      >
                        Access Partner Inquiry Form
                        <svg
                          className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </div>

                    {/* Users Card */}
                    <div className="bg-gray-50 rounded-lg p-6 hover:bg-white transition-all border border-gray-100 hover:border-purple-200 hover:shadow-md">
                      <div className="flex items-center mb-4">
                        <div className="bg-cyan-100 p-3 rounded-full mr-4 flex-shrink-0">
                          <svg
                            className="h-6 w-6 text-cyan-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                            />
                          </svg>
                        </div>
                        <h4 className="text-lg font-bold text-gray-800">
                          Users
                        </h4>
                      </div>
                      <p className="text-gray-600 mb-4">
                        Hiring companies & households - Find part-time help for
                        your short-term needs.
                      </p>
                      <a
                        href={info?.google_form_worker || "#"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-purple-600 hover:text-purple-800 font-medium group"
                      >
                        Access User Inquiry Form
                        <svg
                          className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="py-12 px-6 max-w-7xl mx-auto">
        <div className="text-center flex flex-col items-center">
          <h2 className="text-4xl font-bold">Domestic Services</h2>
          <p className="text-gray-800 text-md mt-3 w-full md:w-1/3">
            There are many variations of passages of Lorem Ipsum available but
            the majority have suffered alteration
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
          {serviceOption.map(
            (service, idx) =>
              service.service_type === "Domestic" && (
                <div
                  key={`${service.id}-${idx}`}
                  className="bg-white shadow-md rounded-lg overflow-hidden"
                >
                  <img
                    src={service.subcategory_image}
                    alt={service.subcategory_name}
                    className="w-full h-52 object-cover"
                  />

                  <div className="p-4">
                  

                    <h3 className="text-lg font-semibold line-clamp-1">
                      {service.subcategory_name}
                    </h3>
                    <div className="line-clamp-4 text-sm text-gray-800">
                      {service.description}
                    </div>

                    <button className="mt-4 w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600">
                      Get Now
                    </button>
                  </div>
                </div>
              )
          )}
        </div>
      </section> */}

      {/* <section className="py-12 px-6 max-w-7xl mx-auto">
        <div className="text-center flex flex-col items-center">
          <h2 className="text-4xl font-bold">Commercial Services</h2>
          <p className="text-gray-800 text-md mt-3 w-full md:w-1/3">
            There are many variations of passages of Lorem Ipsum available but
            the majority have suffered alteration
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-10">
          {serviceOption.map(
            (service, idx) =>
              service.service_type === "Commercial" && (
                <div
                  key={`${service.id}-${idx}`}
                  className="bg-white shadow-md rounded-lg overflow-hidden"
                >
                  <img
                    src={service.subcategory_image}
                    alt={service.subcategory_name}
                    className="w-full h-52 object-cover"
                  />

                  <div className="p-4">
                  

                    <h3 className="text-lg font-semibold line-clamp-1">
                      {service.subcategory_name}
                    </h3>
                    <div className="line-clamp-4 text-sm text-gray-800">
                      {service.description}
                    </div>

                    <button className="mt-4 w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600">
                      Book Now
                    </button>
                  </div>
                </div>
              )
          )}
        </div>
      </section> */}

      <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Our Specialized Service Categories
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Connecting you with top-tier professionals across all service
              categories
            </p>
          </div>

          {/* Service Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Commercial Services Card */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-48 bg-gradient-to-r from-blue-600 to-blue-400 relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                  alt="Commercial Services"
                  className="w-full h-full object-cover opacity-70"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <h3 className="text-2xl font-bold text-white text-center px-4">
                    Commercial Support Services
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Office maintenance & cleaning</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Commercial security services</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Corporate event staffing</span>
                  </li>
                </ul>
                <button className="mt-6 w-full py-2.5 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors duration-300">
                  Explore Services
                </button>
              </div>
            </div>

            {/* Domestic Services Card */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-48 bg-gradient-to-r from-green-600 to-green-400 relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                  alt="Domestic Services"
                  className="w-full h-full object-cover opacity-70"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <h3 className="text-2xl font-bold text-white text-center px-4">
                    Domestic Support Services
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>House cleaning & maintenance</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Child & elderly care</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-green-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Home cooking & meal prep</span>
                  </li>
                </ul>
                <button className="mt-6 w-full py-2.5 px-4 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors duration-300">
                  Explore Services
                </button>
              </div>
            </div>

            {/* Professionals & Vendor Services Card */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="h-48 bg-gradient-to-r from-purple-600 to-purple-400 relative overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
                  alt="Professional Services"
                  className="w-full h-full object-cover opacity-70"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <h3 className="text-2xl font-bold text-white text-center px-4">
                    Professionals & Vendor Services
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Skilled trades & technicians</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>IT & technical support</span>
                  </li>
                  <li className="flex items-start">
                    <svg
                      className="h-5 w-5 text-purple-500 mt-0.5 mr-2 flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    <span>Professional consultants</span>
                  </li>
                </ul>
                <button className="mt-6 w-full py-2.5 px-4 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-300">
                  Explore Services
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="relative bg-cover bg-center py-20"
        style={{
          backgroundImage:
            "url('https://demo.websolutionus.com/aabcserv/uploads/website-images/counter-bg--2022-09-29-12-43-47-5215.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-70"></div>

        <div className="relative z-10 container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-white text-center">
            {stats.map((stat, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="size-20 flex items-center justify-center bg-white rounded-full shadow-lg mb-4 p-4">
                  {stat.icon}
                </div>
                <h2 className="text-4xl font-bold">{stat.value}</h2>
                <p className="text-lg font-medium">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        className="relative my-16 py-20 px-6 text-center text-white"
        style={{
          backgroundImage:
            "url('https://demo.websolutionus.com/aabcserv/uploads/website-images/join-provider-bg--2022-12-03-06-07-16-1842.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="relative z-10 max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold">
            Discover a world of possibilities{" "}
            <span className="text-white">join us</span> and explore
            <span className="text-white"> our platform</span> now!
          </h2>

          <button
            onClick={() => navigate("/contact")}
            className="mt-6 bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold shadow-md hover:bg-gray-200 transition"
          >
            Join us
          </button>
        </div>
      </section>

      {/* <section className="flex flex-col md:flex-row items-center justify-between px-6 md:px-16 py-12 bg-white">
        <div className="md:w-1/2 text-center md:text-left">
          <h5 className="text-blue-500 font-semibold mb-2">Download Now</h5>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            App is available for free on <br /> Google Play & App Store
          </h2>
          <p className="text-gray-600 mb-6 font-medium">
            Get the latest resources for downloading, installing, and updating
            our app. Select your device platform & enjoy using our app!
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#"
              className="bg-blue-600 text-white px-6 py-3 rounded-lg flex items-center gap-2 shadow-lg hover:bg-blue-700 transition"
            >
              <FaGooglePlay className="size-8" />

              <span>
                Available on the <br />
                <strong>Google Play</strong>
              </span>
            </a>
            <a
              href="#"
              className="bg-blue-600 text-white px-6 py-3 rounded-lg flex items-center gap-2 shadow-lg hover:bg-blue-700 transition"
            >
              <FaApple className="size-8" />
              <span>
                Download on the <br />
                <strong>App Store</strong>
              </span>
            </a>
          </div>
        </div>

        <div className="md:w-1/2 flex justify-center mt-10 md:mt-0 relative">
          <div className="relative w-60 h-96 md:w-full md:h-[28rem]">
            <img
              src="https://demo.websolutionus.com/aabcserv/uploads/website-images/mobile-app-bg--2022-08-29-01-17-54-3596.png"
              alt="App Screenshot"
              className="size-full object-contain"
            />
          </div>
        </div>
      </section> */}

      <section className="relative overflow-hidden bg-gradient-to-br from-indigo-900 to-purple-800 py-16 px-6 md:px-16">
        {/* Decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full opacity-10">
          <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-purple-400"></div>
          <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full bg-indigo-400"></div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between relative z-10 max-w-6xl mx-auto">
          <div className="md:w-1/2 text-center md:text-left mb-12 md:mb-0">
            <div className="inline-block bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-4">
              <span className="text-white font-medium">
                For Part-Time Workers
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Earn Flexible Income <br className="hidden md:block" /> With Our
              Partner App
            </h2>
            <p className="text-white/80 mb-8 text-lg max-w-lg">
              Join thousands of workers finding great part-time opportunities.
              Set your schedule, build your profile, and start earning today!
            </p>

            <h3 className="text-2xl font-bold text-white mb-4 text-center sm:text-left">
              Download Now
            </h3>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="#"
                className="bg-white text-indigo-900 px-6 py-4 rounded-xl flex items-center gap-3 shadow-lg hover:bg-gray-100 transition transform hover:-translate-y-1"
              >
                <FaGooglePlay className="size-8" />
                <span className="text-left">
                  {/* <span className="text-xs block">GET IT ON</span> */}
                  <span className="text-lg font-bold block">Google Play</span>
                </span>
              </a>
              <a
                href="#"
                className="bg-white text-indigo-900 px-6 py-4 rounded-xl flex items-center gap-3 shadow-lg hover:bg-gray-100 transition transform hover:-translate-y-1"
              >
                <FaApple className="size-8" />
                <span className="text-left">
                  {/* <span className="text-xs block">Download on the</span> */}
                  <span className="text-lg font-bold block">App Store</span>
                </span>
              </a>
            </div>
          </div>

          <div className="md:w-1/2 flex justify-center relative">
            <div className="relative w-64 h-[28rem] md:w-72 md:h-[32rem]">
              {/* Phone mockup with screenshot */}
              <div className="absolute inset-0 bg-gray-900 rounded-[2.5rem] p-2 shadow-2xl">
                <div className="relative h-full overflow-hidden rounded-3xl">
                  {/* Screen content */}
                  <img
                    src="https://demo.websolutionus.com/aabcserv/uploads/website-images/mobile-app-bg--2022-08-29-01-17-54-3596.png"
                    alt="Partner App Screenshot"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  {/* Notch */}
                  <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/3 h-6 bg-gray-900 rounded-b-xl z-10"></div>
                </div>
              </div>
              {/* Reflection effect */}
              <div className="absolute inset-0 rounded-[2.5rem] overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/5 to-transparent pointer-events-none"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white py-16 px-6 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            {/* Phone mockup */}
            <div className="lg:w-1/2 relative">
              <div className="relative w-64 h-[28rem] md:w-72 md:h-[32rem] mx-auto">
                {/* Phone frame with shadow */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-50 rounded-[3rem] p-3 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.15)]">
                  <div className="relative h-full overflow-hidden rounded-[2.5rem] border border-gray-200">
                    {/* Screen content */}
                    <img
                      src="https://demo.websolutionus.com/aabcserv/uploads/website-images/mobile-app-bg--2022-08-29-01-17-54-3596.png"
                      alt="User App Screenshot"
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    {/* Camera notch */}
                    <div className="absolute top-4 left-1/2 transform -translate-x-1/2 w-1/4 h-6 bg-gray-900 rounded-full z-10"></div>
                  </div>
                </div>
                {/* Decorative dots */}
                <div className="absolute -bottom-8 -left-8 w-16 h-16 rounded-full bg-blue-100 z-0"></div>
                <div className="absolute -top-8 -right-8 w-20 h-20 rounded-full bg-purple-100 z-0"></div>
              </div>
            </div>

            {/* Content */}
            <div className="lg:w-1/2 text-center lg:text-left">
              <h5 className="text-blue-600 font-semibold mb-3">
                HIRE TALENT NOW
              </h5>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                Find Qualified Help <br className="hidden lg:block" /> For Your
                Business <br className="hidden lg:block" /> & Home
              </h2>
              <p className="text-gray-600 mb-8 text-lg max-w-lg mx-auto lg:mx-0">
                Connect with verified part-time professionals for all your
                needs. Post jobs, review profiles, and hire with just a few
                taps.
              </p>

              <div className="max-w-md mx-auto sm:mx-0">
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center sm:text-left">
                  Download Now
                </h3>
                <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                  <a
                    href="#"
                    className="bg-gray-900 text-white px-6 py-4 rounded-xl flex items-center gap-3 shadow-lg hover:bg-gray-800 transition-all transform hover:scale-105 active:scale-95"
                  >
                    <FaGooglePlay className="size-6" />
                    <span className="text-left">
                      {/* <span className="text-xs font-medium block opacity-80">
                        Get it on
                      </span> */}
                      <span className="text-lg font-bold block">
                        Google Play
                      </span>
                    </span>
                  </a>
                  <a
                    href="#"
                    className="bg-gray-900 text-white px-6 py-4 rounded-xl flex items-center gap-3 shadow-lg hover:bg-gray-800 transition-all transform hover:scale-105 active:scale-95"
                  >
                    <FaApple className="size-6" />
                    <span className="text-left">
                      {/* <span className="text-xs font-medium block opacity-80">
                        Download on the
                      </span> */}
                      <span className="text-lg font-bold block">App Store</span>
                    </span>
                  </a>
                </div>
              </div>

              {/* Trust indicators */}
              <div className="mt-12 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6">
                <div className="flex items-center gap-2">
                  <div className="flex -space-x-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div
                        key={i}
                        className="w-8 h-8 rounded-full bg-blue-500 border-2 border-white"
                      ></div>
                    ))}
                  </div>
                  <span className="text-sm font-medium text-gray-600">
                    10K+ Active Workers
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="flex items-center justify-center w-8 h-8 bg-yellow-400 rounded-full">
                    <FaStar className="text-white text-sm" />
                  </div>
                  <span className="text-sm font-medium text-gray-600">
                    4.9 Rating (5K+ reviews)
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* General Inquiry CTA */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-xl overflow-hidden">
          <div className="p-8 sm:p-12 text-center">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Have Questions?
            </h3>
            <p className="text-blue-100 text-lg mb-6">
              We're happy to hear from you! Contact us for any inquiries about
              our services.
            </p>
            <Link
              // href="#"
              to={"/contact"}
              className="inline-flex items-center px-6 py-3 bg-white text-blue-600 font-medium rounded-lg hover:bg-blue-50 transition shadow-md"
            >
              Contact Us
              <svg
                className="ml-2 -mr-1 w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <CustomTestimonialSlider />
      <FAQs />
    </div>
  );
};

export default Home;
